import constants from '../constants/index';

export default function authenticated(state = false, action) {
	let newState = state;
	
	switch(action.type) {
		case constants.REQUEST_AUTHENTICATION_FAIL:
			newState = false;
			break;
		case constants.REQUEST_AUTHENTICATION_SUCCESS:
			newState = action.payload.authenticated;
			break;
		default:
	}
	return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/authenticated_reducer.js
 **/